import BaseClient from '../base/baseClient';
import endpoint from '../../features/endPoints/ecommEndpoints';

const resetPasswordTokenValidateClient = async (body) => {

  const { post: postClient } = BaseClient();

  try{
    return await postClient(process.env.REACT_APP_ECOMM_URL+endpoint.resetPasswordTokenValidate(), body, {}, false);
  } catch(error) {
    return { error: 'Some error occured. Please try again' };
  }
};

export default resetPasswordTokenValidateClient;
